import React, { useState } from "react";
import { ReactComponent as ArrowRight } from "assets/icons/arrow_right.svg";
import { ReactComponent as DeleteIcon } from "assets/icons/delete_fill.svg";
import { useNavigate } from "react-router";
import { formatLocationName } from "utils/commonUtils";
import BaseMap from "components/Map/BaseMap";
import { Marker, Popup } from "react-leaflet";
import { DivIcon } from "leaflet";
import locationPin from "assets/icons/location_pin.svg";

const SaveSearchCard = ({
  searchInfo,
  isDeleteVisible = false,
  imgStyle,
  contentStyle,
  onDelete = () => {},
}) => {
  const navigation = useNavigate();

  const newPropertes =
    searchInfo?.propertiesCount - searchInfo?.properties?.count;

  return (
    <>
      <div className="flex w-full items-center flex-col md:flex-row h-full">
        <div
          style={imgStyle}
          className="relative w-full lg:w-[271px] h-[243px] lg:h-full rounded-[18px] "
        >
          <BaseMap
            mapStyle={{ borderRadius: 18, height: "100%" }}
            visibleZoom={false}
            zoomLevel={11}
          >
            {searchInfo?.properties?.results?.length > 0 &&
              searchInfo?.properties.results.map(
                (property, index) =>
                  property?.coordinates?.coordinates?.length > 0 && (
                    <Marker
                      key={index}
                      position={[
                        property.coordinates.coordinates[1],
                        property.coordinates.coordinates[0],
                      ]}
                      icon={
                        new DivIcon({
                          html: `
                      <div class="">
                       <img src="${locationPin}" width="38" height="38" alt="Location Pin" />
                      </div>
                    `,
                          iconSize: [38, 38],
                          className: "",
                        })
                      }
                    ></Marker>
                  )
              )}
          </BaseMap>
        </div>
        <div
          style={contentStyle}
          className="w-full lg:w-[338px] mt-[16px] md:mt-0 md:ml-[32px]"
        >
          <h1 className="text-[24px] font-semibold leading-[30px] text-white line-clamp-1">
            {searchInfo?.searchName}
          </h1>
          <div className="mt-[11px] flex items-center capitalize space-x-[6px] text-[16px] font-normal text-[#EEEEEE] leading-[20px]">
            <p>{formatLocationName(searchInfo?.location)}</p>
          </div>
          <p className="mt-[7px] leading-[20px] text-[16px] text-white">
            <span className="text-[20px] font-bold text-primary">
              {searchInfo?.propertiesCount}{" "}
            </span>
            Proprietà totali Trovate
          </p>
          <p className="underline text-[16px] text-primary font-semibold leading-[30px] mt-[13px] cursor-pointer">
            {newPropertes} Nuove Proprietà da Vedere
          </p>
          <div className="flex mt-[14px] md:mt-5 items-center space-x-2">
            <div
              onClick={() => navigation(searchInfo?.url)}
              className="bg-white flex-1  rounded-[6px] h-10 flex items-center max-w-[193px] justify-between px-[11px] cursor-pointer"
            >
              <p className="text-[16px] font-semibold text-black">
                Vai alla Ricerca
              </p>
              <ArrowRight className="w-[14px] h-[14px]" />
            </div>
            {isDeleteVisible && (
              <div
                onClick={onDelete}
                className="cursor-pointer w-[39px] h-[40px] rounded-[6px] bg-white grid place-items-center"
              >
                <DeleteIcon className="text-[#F60000] fill-[#F60000] icon-red" />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default SaveSearchCard;
